import { t } from "@web-monorepo/i18n/macro";
import { clsx } from "clsx";
import type React from "react";
import type { AppPageVariant } from "src/shared/components/AppPage";
import styles from "./SavedToolNewButton.module.css";

interface SavedToolNewButtonProps {
  onClick: VoidFunction;
  children: React.ReactNode;
  /**
   * Pod variant — drives the button's brand background + text color via
   * `.variant<name>` rules in the CSS Module. Sourced from each pod's
   * `appMetadata.variant` so adding a new pod only requires extending the
   * AppPageVariant union and adding a new rule here.
   */
  variant: AppPageVariant;
}

export default function SavedToolNewButton({ onClick, children, variant }: SavedToolNewButtonProps) {
  return (
    <li>
      <button
        type="button"
        data-name="saved_tool_new_button:create_new_item"
        aria-label={t`Create new item`}
        onClick={onClick}
        className={clsx(styles.button, styles[variant])}
      >
        <span className={styles.text}>{children}</span>
      </button>
    </li>
  );
}
